<template>
<div id="jobList">
  <div class="job-wrap">
      <div class="search-box">
        <el-input placeholder="搜索职位、公司"></el-input>
        <div class="search-icon">
          搜索
        </div>
    </div>
  </div>
</div>
</template>

<script>
// import {  viewPersonalApprovalStatus } from "@/api/index.js";
export default {
  name: "verify",
  data() {
    return {

    }
  },
  mounted(){
    
  },
  methods: {
  
  }
};
</script>

<style lang="scss" scoped>
#jobList {
  width: 100%;
  min-height: 514px;
  background: linear-gradient(0deg, #F5F5F5 1%, #D6E9FF 100%);
  padding-bottom: 30px;
  padding-top: 24px;
}
.job-wrap{
  width: 1200px;
  margin: 0 auto;
}
.search-box{
  min-height:80px;
  background: #FFFFFF;
  padding: 30px 100px;
  .search-icon{
    width: 150px;
height: 80px;
line-height: 80px;
text-align: center;
background: #0077FF;
border-radius: 0px 5px 5px 0px;
font-size: 30px;
cursor: pointer;
color: #FFFFFF;
float: left;
  }
}
</style>
<style lang="scss">
.search-box{
  .el-input{
      width: 850px;
      float: left;
  }
  .el-input__inner{
height: 80px;
background: #FFFFFF;
border: 2px solid #0077FF;
border-radius:5px 0 0 5px;
font-size: 24px;
color: #999999;
  }
}
</style>
